export default __webpack_public_path__ + "static/media/CANCIONES_DISCO_02.75f17a95.png";